import { map, pluck, skipWhile } from 'rxjs/operators'
import { ReduxAction } from '../../../dataStore/reducers/reducerType'
import { Observable } from 'rxjs'
import has from 'lodash/has'

interface PluckFromPayload <Payload = any> {
  payload: Payload
}

/**
 * This function takes an array of Redux actions and allows you to specify which action to take the payload from
 * @param pluckFrom {string} - A Redux action type
 * @returns The requested payload or it returns nothing
 */

export default function pluckFrom (action: string) {

  return function (source: Observable<ReduxAction[]>): Observable<PluckFromPayload> {

    return source.pipe(
      map((events) => events.find(({ type }) => type === action)),
      skipWhile((reduxAction) => !has(reduxAction, 'payload')),
      pluck<ReduxAction | undefined, PluckFromPayload>('payload')
    )

  }

}
